<template>
<div class="columns">
  <div class="column">
    <p class="has-text-primary">{{ name }}</p>
    <p class="has-text-danger" v-if="index === 1 && scraper.invokable_params !== 'any'">
      The first secondary scraper must be able to receive any type of value.
    </p>
    <p>
      Accepts <span class="has-text-warning">{{ scraper.invokable_params }}</span>
      and returns <span class="has-text-warning">{{ scraper.return_value }}</span>
    </p>
  </div>
  <div class="column is-narrow">
    <div class="buttons has-addons">
      <action-button @click="openPayloadEditor" v-if="scraper.scraper_payload" class="is-small is-rounded">
        <icon icon="pencil-alt" />
      </action-button>
      <action-button @click="deleteScraper" class="is-small is-danger is-rounded">
        <icon icon="trash"/>
      </action-button>
    </div>
  </div>
</div>  
</template>
<script>
import { last } from 'lodash'
import { burn } from '@/api/request'
import { editSecondaryScraperPayload } from '@/modals'

export default {
  
  props: {
    index: {
      type: Number
    },
    scraper: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    deleteScraper() {
      burn('api/super/secondary-scraper/' + this.scraper.id, {}, () => {
        this.$store.commit('attributeType/deleteSecondaryScraper', this.scraper)
      })
    },
    openPayloadEditor() {
      editSecondaryScraperPayload(this.scraper).then(reload => {
        if(reload) {
          this.$store.dispatch('attributeType/loadAttributeType', this.$route.params.attributeType)
        }
      })
    }
  },

  computed: {
    name() {
      return last(
        this.scraper.handler.split('\\')
      )
    }
  }
}
</script>